import { useMemo } from 'react';

import { assert } from '../';

/**
 * @deprecated do not use, to be replaced with a new i18n solution in H2 2025
 */
export const useLocales = <T extends Record<LocaleKey, string>>(
	locales: ComponentLocales<T> | undefined,
	defaultValues: T,
) => {
	const t = useMemo(
		() =>
			// Using a Proxy object rather than fully-recreating the object each time, this allows us to lazy load the values
			new Proxy(defaultValues, {
				get: (target: T, prop: keyof T): LocaleValueFn => {
					const value = locales?.[prop] ?? defaultValues?.[prop];

					return (params = {}) =>
						value.replace(/{{(.*?)}}/g, (_, match: string): string => {
							assert(match in params && params[match] !== undefined, `Missing parameter "${match}" in locales`);

							return params?.[match]?.toString?.();
						});
				},
			}),
		[defaultValues, locales],
	);

	// Typescript does not understand the Proxy object, so we need to cast it to the correct type
	return t as unknown as useLocalesReturnType<T>;
};

type LocaleValueFn = (params?: Record<LocaleKey, number | string>) => string;

type LocaleKey = string | symbol;

type useLocalesReturnType<T extends Record<LocaleKey, string>> = {
	[K in keyof T]: LocaleValueFn;
};

export type ComponentLocales<T extends Record<LocaleKey, string>> = {
	[K in keyof T]?: string;
};
